const component = "create-site-section-drawer";

export const createSiteSectionDrawer = {
  component,
  skeleton: `${component}/skeleton`,
  closeButton: `${component}/close-button`,
  targetSectionName: `${component}/target-section-name`,
  submitButton: `${component}/submit-button`,
  cancelButton: `${component}/cancel-button`,
  createForm: {
    form: `${component}/form`,
    nameTextInput: `${component}/form/name-text-input`,
    areaNumberInput: `${component}/form/area-number-input`,
    selectParentTextSelect: `${component}/form/select-parent`,
    categorySelect: `${component}/form/category-select`,
    categoryCreateButton: `${component}/form/category-create-button`,
    categoryCreationInput: `${component}/form/category-creation-input`,
    categoryConfirmButton: `${component}/form/category-confirm-button`,
    categoryCancelButton: `${component}/form/category-cancel-button`,
  },
};
